import { useState } from "react";
import { useLocation } from "react-router-dom";
import { OverlayTrigger } from "react-bootstrap";

import { ScheduleModal } from "../ScheduleModal/ScheduleModal.jsx";

import styles from "./ScheduleButton.module.css";

export const ScheduleButton = ({ data, forming }) => {
  const location = useLocation();
  const isForming = location.pathname === "/schedule/forming/";
  const [showModal, setShowModal] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const { course } = data;

  const colorOfbutton = () => (forming ? "#d1d1d1" : course.module.color);

  const switchTypeOfLesson = () => {
    const result = (children) => <h3 className="m-0">{children}</h3>;
    switch (data.type) {
      case "forming":
        return result("Группа формируется");
      case "adaptation":
        return result("Адаптация");
      case "compensation":
        return result("Компенсация");
      default:
        return null;
    }
  };

  const ScheduleTooltip = ({ show: _, arrowProps: __, ...props }) => {
    return (
      <div className={styles.ScheduleTooltipWrapper} {...props}>
        <div
          className={styles.ScheduleTooltip}
          style={{ borderColor: colorOfbutton() }}
        >
          <div
            className={styles.ScheduleTooltip__body}
            style={{ backgroundColor: colorOfbutton() }}
          >
            <h2>{course.name_first}</h2>
            <div>{course.name_second}</div>
            <div>{course.module.name}</div>
            <div className="text-center">
              <h3 className="my-1">
                <strong>{data.time}</strong>
              </h3>
              {data.room && <h3 className="m-0">кабинет {data.room}</h3>}
              {switchTypeOfLesson()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={ScheduleTooltip}
        trigger={["hover", "hover"]}
        show={showTooltip}
      >
        <button
          className={styles.ScheduleButton}
          style={{ backgroundColor: colorOfbutton() }}
          onClick={() => {
            setShowModal(true);
            setShowTooltip(false);
          }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <div className={styles.ScheduleButton__title}>
            {course.short_name}
          </div>
          {data.room && (
            <div className={styles.ScheduleButton__roomBlock}>
              каб {data.room}
            </div>
          )}
          {(isForming || forming) && (
            <div className={styles.ScheduleButton__freePlaces}>
              мест свободно:{" "}
              <strong>{data.course.max_students - data.taken}</strong>
            </div>
          )}
        </button>
      </OverlayTrigger>
      <ScheduleModal
        data={data}
        showModal={showModal}
        setShowModal={setShowModal}
        colorOfbutton={colorOfbutton}
      />
    </>
  );
};
